<template lang="pug">
    v-container
        v-card
            v-toolbar(flat color="primary" dark)
                v-toolbar-title Основные возможности
            v-tabs
                v-tab
                    v-icon(left) mdi-account
                    | Проверить адрес
                v-tab
                    v-icon(left) mdi-account
                    | Добавить адрес
                v-tab
                    v-icon(left) mdi-account
                    | Удалить адрес
                v-tab
                    v-icon(left) mdi-account
                    | Загрузка с файла
                v-tab-item
                    v-container
                        v-card(flat)
                            v-card-text
                                span.d-flex.mb-4.blue--text Убедитесь в правильном заполнении всех полей. В случае ошибки, адрес не будет найден (cтрогое сравнение). Проверка работает только по адресам, которые были добавлены вручную.
                                v-btn.mb-5(text color="primary" @click="clearCheck") Очистить все поля
                                v-row
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Город (Original - uk)"
                                            v-model="check.city"
                                            placeholder="Введите город"
                                            outlined
                                            :error-messages="getValidateMessage('Address', 'check.city', 'city')"
                                        )
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Улица (Original - uk)"
                                            placeholder="Введите улицу"
                                            v-model="check.street"
                                            :error-messages="getValidateMessage('Address', 'check.street', 'street')"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Место"
                                            v-model="check.name"
                                            placeholder="Введите место (если есть)"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Район (Original - uk)"
                                            v-model="check.district"
                                            placeholder="Введите район (если есть, например: Вишенка)"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Номер дома"
                                            placeholder="Введите номер дома"
                                            v-model="check.house"
                                            outlined
                                        )
                                v-card(v-if="checkResult")
                                    v-card-title Результат
                                    v-card-text
                                        vue-json-pretty(
                                            showLine
                                            showLength
                                            highlightMouseoverNode
                                            highlightSelectedNode
                                            selectOnClickNode
                                            :deep="3"
                                            :data="checkResult"
                                        )
                            v-card-actions
                                v-btn(
                                    width="100%" color="primary" @click="searchAddress"
                                    :disabled="loading"
                                ) Найти
                v-tab-item
                    v-container
                        v-card(flat)
                            v-card-text
                                span.d-flex.mb-4.blue--text Убедитесь в правильном заполнении всех полей.
                                v-btn.mb-5(text color="primary" @click="clearAdd") Очистить все поля
                                v-row
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Город (uk)"
                                            v-model="add['city:uk']"
                                            placeholder="Введите город"
                                            outlined
                                            :error-messages="getValidateMessage('Address', 'add.city:uk', 'city')"
                                        )
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Город (ru)"
                                            v-model="add['city:ru']"
                                            placeholder="Введите город"
                                            outlined
                                            :error-messages="getValidateMessage('Address', 'add.city:ru', 'city')"
                                        )
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Город (en)"
                                            v-model="add['city:en']"
                                            placeholder="Введите город"
                                            outlined
                                            :error-messages="getValidateMessage('Address', 'add.city:en', 'city')"
                                        )
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Район (uk)"
                                            placeholder="Введите район (если есть)"
                                            v-model="add['district:uk']"
                                            :error-messages="getValidateMessage('Address', 'add.district:uk', 'district')"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Район (ru)"
                                            placeholder="Введите район (если есть)"
                                            v-model="add['district:ru']"
                                            :error-messages="getValidateMessage('Address', 'add.district:ru', 'district')"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Район (en)"
                                            placeholder="Введите район (если есть)"
                                            v-model="add['district:en']"
                                            :error-messages="getValidateMessage('Address', 'add.district:en', 'district')"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Улица (uk)"
                                            placeholder="Введите улицу"
                                            v-model="add['street:uk']"
                                            :error-messages="getValidateMessage('Address', 'add.street:uk', 'street')"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Улица (ru)"
                                            placeholder="Введите улицу"
                                            v-model="add['street:ru']"
                                            :error-messages="getValidateMessage('Address', 'add.street:ru', 'street')"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Улица (en)"
                                            placeholder="Введите улицу"
                                            v-model="add['street:en']"
                                            :error-messages="getValidateMessage('Address', 'add.street:en', 'street')"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Место"
                                            v-model="add.name"
                                            :error-messages="getValidateMessage('Address', 'add.name', 'name')"
                                            placeholder="Введите место (если есть)"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Номер дома"
                                            placeholder="Введите номер дома"
                                            v-model="add.house"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="4")
                                        v-text-field(
                                            label="Коефициент"
                                            type="number"
                                            placeholder="Введите коефициент"
                                            :error-messages="getValidateMessage('Address', 'add.importance', 'importance')"
                                            v-model="add.importance"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Широта"
                                            type="number"
                                            placeholder="Введите широту"
                                            :error-messages="getValidateMessage('Address', 'add.latitude', 'latitude')"
                                            v-model="add.latitude"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Долгота"
                                            type="number"
                                            placeholder="Введите долготу"
                                            :error-messages="getValidateMessage('Address', 'add.longitude', 'longitude')"
                                            v-model="add.longitude"
                                            outlined
                                        )
                                v-card(v-if="addResult")
                                    v-card-title Результат
                                    v-card-text
                                        vue-json-pretty(
                                            showLine
                                            showLength
                                            highlightMouseoverNode
                                            highlightSelectedNode
                                            selectOnClickNode
                                            :deep="3"
                                            :data="addResult"
                                        )
                            v-card-actions
                                v-btn(
                                    width="100%" color="success" @click="addAddress"
                                    :disabled="loading"
                                ) Добавить
                v-tab-item
                    v-container
                        v-card(flat)
                            v-card-text
                                span.d-flex.mb-4.blue--text Убедитесь в правильном заполнении всех полей. В случае ошибки, адрес не будет удален. Удаление работает только по адресам, которые были добавлены вручную.
                                v-btn.mb-5(text color="primary" @click="clearRemove") Очистить все поля
                                v-row
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Город (Original - uk)"
                                            v-model="remove.city"
                                            placeholder="Введите город"
                                            outlined
                                            :error-messages="getValidateMessage('Address', 'remove.city', 'city')"
                                        )
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Улица (Original - uk)"
                                            placeholder="Введите улицу"
                                            v-model="remove.street"
                                            :error-messages="getValidateMessage('Address', 'remove.street', 'street')"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Место"
                                            v-model="remove.name"
                                            placeholder="Введите место (если есть)"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Район (Original - uk)"
                                            v-model="remove.district"
                                            placeholder="Введите район (если есть, например: Вишенка)"
                                            outlined
                                        )
                                    v-col.py-0(cols="12" sm="6")
                                        v-text-field(
                                            label="Номер дома"
                                            placeholder="Введите номер дома"
                                            v-model="remove.house"
                                            outlined
                                        )
                                v-card(v-if="removeResult")
                                    v-card-title Результат
                                    v-card-text
                                        vue-json-pretty(
                                            showLine
                                            showLength
                                            highlightMouseoverNode
                                            highlightSelectedNode
                                            selectOnClickNode
                                            :deep="3"
                                            :data="removeResult"
                                        )
                            v-card-actions
                                v-btn(
                                    width="100%" color="error" @click="removeAddress"
                                    :disabled="loading"
                                ) Удалить
                v-tab-item
                    v-container
                        v-card(flat)
                            v-card-text
                                span.d-flex.blue--text Выберите нужный файл (только с расширением .csv - разделитель ";")
                                v-btn(text color="primary" @click="clearAddFile") Очистить все поля
                                v-row
                                    v-col
                                        v-file-input(
                                            accept=".csv"
                                            v-model="file"
                                            outlined
                                            placeholder="Выберите файл"
                                            show-size
                                        )
                                v-card(v-if="addFileResult")
                                    v-card-title Результат
                                    v-card-text
                                        vue-json-pretty(
                                            showLine
                                            showLength
                                            highlightMouseoverNode
                                            highlightSelectedNode
                                            selectOnClickNode
                                            :deep="3"
                                            :data="addFileResult"
                                        )
                            v-card-actions
                                v-btn(
                                    width="100%" color="success" @click="sendFile"
                                    :disabled="loading || !file"
                                ) Загрузить
</template>

<style scoped lang="scss">

</style>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import validate from '@/mixins/validate';
import request from '@/utils/request';
import VueJsonPretty from 'vue-json-pretty'

function generateFiels(prop) {
    return ['uk', 'ru', 'en'].map(locale => `${prop}:${locale}`);
}

const demical = (value) => {
    if (!value) {
        return true;
    }

    return Number(value) == value;
};

const addAddressState = () => Object.assign({
    'city:uk': 'Вінниця',
    'city:ru': 'Винница',
    'city:en': 'Vinnytsia',
    importance: 0,
    house: null,
    name: null,
    latitude: null,
    longitude: null
},
    ...generateFiels('street').map(it => ({ [it]: null })),
    ...generateFiels('district').map(it => ({ [it]: null })),
);

const defaultState = () => ({
    street: null,
    name: null,
    city: null,
    district: null,
    house: null
});

export default {
    mixins: [validationMixin, validate],
    name: 'Home',
    components: {
        VueJsonPretty
    },
    data: () => ({
        check: defaultState(),
        remove: defaultState(),
        add: addAddressState(),
        checkResult: null,
        removeResult: null,
        addResult: null,
        addFileResult: null,
        loading: false,
        file: null
    }),
    watch: {
        check: {
            handler() {
                this.checkResult = null
            },
            deep: true
        },
        add: {
            handler() {
                this.addResult = null
            },
            deep: true
        },
        remove: {
            handler() {
                this.removeResult = null
            },
            deep: true
        }
    },
    validations: {
        check: {
            city: {
                required
            }
        },
        remove: {
            city: {
                required
            }
        },
        add: {
            ...Object.assign({}, ...generateFiels('street').map(it => ({
                [it]: {
                    required: function(val) {
                        if (val) return true;
                        if (!this.add.name) return false;
                        return !generateFiels('street').some(it => !!this.add[it]);
                    }
                }
            }))),
            ...Object.assign({}, ...generateFiels('district').map(it => ({
                [it]: {
                    required: function(val) {
                        if (val) return true;
                        return !generateFiels('district').some(it => !!this.add[it]);
                    }
                }
            }))),
            ...Object.assign({}, ...generateFiels('city').map(it => ({
                [it]: {
                    required
                }
            }))),
            name: {
                required: function(val) {
                    if (val) return true;
                    return generateFiels('street').some(it => !!this.add[it]);
                }
            },
            latitude: {
                required,
                demical
            },
            longitude: {
                required,
                demical
            },
            importance: {
                required
            }
        }
    },
    methods: {
        async searchAddress() {
            if (this.$v.check.$invalid) {
                return this.$v.check.$touch()
            }

            if (this.loading) return;

            this.loading = true;

            await request({
                method: 'post',
                url: '/address/check',
                data: this.check
            }).then(res => {
                if (res.status == 200) {
                    this.checkResult = res.data;
                }
            }).catch(err => {
                this.$notify({
                    group: 'app',
                    title: 'Ошибка поиска',
                    type: 'error',
                    text: `Ошибка: ${err && err.response && err.response.data}`
                });
            })

            setTimeout(() => this.loading = false, 1500)
        },

        async removeAddress() {
            if (this.$v.remove.$invalid) {
                return this.$v.remove.$touch()
            }

            if (this.loading) return;

            this.loading = true;

            await request({
                method: 'post',
                url: '/address/remove',
                data: this.remove
            }).then(res => {
                if (res.status == 200) {
                    this.removeResult = res.data;
                }
            }).catch(err => {
                this.$notify({
                    group: 'app',
                    title: 'Ошибка удаления',
                    type: 'error',
                    text: `Ошибка: ${err && err.response && err.response.data}`
                });
            })

            setTimeout(() => this.loading = false, 1500)
        },

        async addAddress() {
            if (this.$v.add.$invalid) {
                return this.$v.add.$touch()
            }

            if (this.loading) return;

            this.loading = true;

            await request({
                method: 'post',
                url: '/address/add',
                data: this.add
            }).then(res => {
                if (res.status == 200) {
                    this.addResult = res.data;
                }
            }).catch(err => {
                this.$notify({
                    group: 'app',
                    title: 'Ошибка добавления',
                    type: 'error',
                    text: `Ошибка: ${err && err.response && err.response.data}`
                });
            })

            setTimeout(() => this.loading = false, 1500)
        },

        clearAdd() {
            this.add = addAddressState();
            this.addResult = null;
            this.$v.add.$reset();
        },

        clearCheck() {
            this.check = defaultState();
            this.checkResult = null;
            this.$v.check.$reset();
        },

        clearRemove() {
            this.remove = defaultState();
            this.removeResult = null;
            this.$v.remove.$reset();
        },

        clearAddFile() {
            this.file = null;
            this.addFileResult = null;
        },

        async sendFile() {
            if (this.loading) return;

            this.loading = true;

            const formData = new FormData();

            formData.append("dataFile", this.file);
            
            await request({
                method: 'post',
                url: '/address/file',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 60000,
                data: formData
            }).then(res => {
                if (res.status == 200) {
                    this.addFileResult = res.data;
                }
            }).catch(err => {
                this.$notify({
                    group: 'app',
                    title: 'Ошибка загрузки',
                    type: 'error',
                    text: `Ошибка: ${err && err.response && err.response.data}`
                });
            })

            setTimeout(() => this.loading = false, 1500)
        }
    }
}
</script>
